<script>
    import { links } from "svelte-routing";

    export let model_root;

    let menuItems = loadMenuItems(0);
    let footerItems = loadMenuItems(1);

    function loadMenuItems(footer) {
        return fetch(model_root + 'shared/menu/load_menu_items.php?footer='+footer, {
            method: "GET"
        })
            .then(response => response.json());
    }

    function logout() {
        return fetch(model_root + 'admin/user_management/logout.php', {
            method: "GET"
        })
            .then(response => response.text())
            .then(msg => {
                if (msg === "success") {
                    window.open("/", "_self");
                }
            });
    }

</script>

<div use:links>
    <h1 class="py-3 bg-white">
        <img src="https://www.maleck.org/us/img/logo_v3_test.png" height="33px" class="">
        <span title="Ausloggen" role="button" on:click={logout}><i class="fas fa-sign-out-alt float-end ms-2 mt-2 text-blue"></i></span>
        <a href="/settings/profile/" class="text-decoration-none text-blue">
            <span title="Mein Account"><i class="fas fa-user-circle float-end ms-2 mt-2"></i></span>
        </a>
        <a href="/settings/" class="text-decoration-none text-blue">
            <span title="FujanaCMS Einstellungen"><i class="fas fa-cog float-end mt-2"></i></span>
        </a>
    </h1>
    <h2 class="pb-3">
        FujanaCMS
    </h2>
    <div class="list-group">
        <a href="/" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white">
            <b>Start</b>
        </a>
        <a href="#" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white">
            <b>Seiteninhalte</b>
            <div class="list-group list-group-flush mt-1 mb-0 ms-2 ps-1">
                {#await menuItems}
                    <a href="#" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white">
                        <i class="fas fa-circle-notch fa-spin"></i> Lade Inhalte...
                    </a>
                {:then data}
                    {#each data as item}
                        {#if item.mparent === null}
                            <a href="/menu-item/{item.mid}" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="far fa-sticky-note"></i> {@html item.mname}</a>
                            <div class="list-group list-group-flush mt-1 mb-0 ms-2 ps-3">
                                {#each data as subitem}
                                    {#if subitem.mparent === item.mid}
                                        <a href="/menu-item/{subitem.mid}" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="far fa-sticky-note"></i> {@html subitem.mname}</a>
                                        <div class="list-group list-group-flush mt-1 mb-0 ms-2 ps-3">
                                            {#each data as subsubitem}
                                                {#if subsubitem.mparent === subitem.mid}
                                                    <a href="/menu-item/{subsubitem.mid}" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="far fa-sticky-note"></i> {@html subsubitem.mname}</a>
                                                {/if}
                                            {/each}
                                        </div>
                                    {/if}
                                {/each}
                            </div>
                        {/if}
                    {/each}
                {:catch error}
                    <p style="color: red">{error.message}</p>
                {/await}
                <a href="/menu-administration" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="fas fa-cog"></i> Menü-Verwaltung</a>
            </div>
        </a>
        <a href="#" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white">
            <b>Fußbereich (Footer)</b>
            <div class="list-group list-group-flush mt-1 mb-0 ms-2 ps-1">
                {#await footerItems}
                    <a href="#" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white">
                        <i class="fas fa-circle-notch fa-spin"></i> Lade Inhalte...
                    </a>
                {:then data}
                    {#each data as item}
                        {#if item.mparent === null}
                            <a href="/menu-item/{item.mid}" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="far fa-sticky-note"></i> {@html item.mname}</a>
                        {/if}
                    {/each}
                {:catch error}
                    <p style="color: red">{error.message}</p>
                {/await}
                <a href="/footer-administration" class="list-group-item list-group-item-action px-2 text-white bg-transparent border-white"><i class="fas fa-cog"></i> Footer-Verwaltung</a>
            </div>
        </a>
    </div>
    <br>
    <small class="text-white text-uppercase footnote">
        &copy; 2021-2023 by Moritz Maleck
    </small>
</div>

<style>
    h1 {
        font-weight: bolder;
        font-family: "Open Sans",sans-serif;
        font-size: 16px;
        text-transform: uppercase;
        color: #fff;

        border-left: solid 1px #f8f9fa;
        border-right: solid 1px #f8f9fa;

        margin: -5px -24px 21px;
        padding-left: 22px;
        padding-right: 22px;
    }

    h2 {
        font-weight: bolder;
        font-family: "Open Sans",sans-serif;
        font-size: 16px;
        color: #fff;
    }

    .footnote {
        font-weight: lighter;
    }
    .text-blue {
        color: #2c3e50;
    }
</style>
